import type { FieldValues } from "react-hook-form";

import { FormField, FormItem } from "@/components/ui/form";

import BaseSelectOptions from "./BaseSelectOptions";
import type { SelectOptionsProps } from "./types";

const SelectOptionsWithoutValidation = <T extends FieldValues>({
  selectList,
  title,
  form,
  name,
  disabled = false,
}: SelectOptionsProps<T>) => (
  <FormField
    control={form}
    name={name}
    render={({ field }) => {
      const selected: string[] = field.value ?? [];

      return (
        <FormItem
          className="gap-3"
          data-testid={`select-options-field-${String(name)}`}
        >
          <p className="text-sm text-gray-950 font-bold">{title}</p>
          <BaseSelectOptions
            selectList={selectList}
            selected={selected}
            onChange={field.onChange}
            disabled={disabled}
          />
        </FormItem>
      );
    }}
  />
);

export default SelectOptionsWithoutValidation;
